var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.4 27.5",
    style: {
      enableBackground: "new 0 0 25.4 27.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1044_1_",
    transform: "translate(64.767 62.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_506_1_",
    className: "st0",
    d: "M-52-36.2c1.5,0,2.8-0.9,3.6-2.1c0.8-1.3,2.2-2.2,3.8-2.3c2.7-0.2,3.5-1.8,3.5-1.8 s2-2.3,0.4-4.4c-0.9-1.4-1-3.2-0.1-4.6c0.6-1.4,0.6-2.9,0-4.3c-0.8-1.2-2.1-2-3.6-2.2c-1.6,0.1-3.1-0.7-3.9-2.1s-2.2-2.2-3.8-2.2 c-1.6,0-3,0.9-3.8,2.2c-0.8,1.4-2.3,2.2-3.9,2.1c-1.4,0.1-2.8,0.9-3.5,2.2c-0.6,1.4-0.6,2.9,0,4.3c0.8,1.4,0.8,3.2-0.1,4.6 c-1.6,2.2,0.4,4.4,0.4,4.4s0.8,1.5,3.5,1.8c1.6,0.1,3,1,3.8,2.3C-54.8-37.2-53.4-36.2-52-36.2L-52-36.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3_1_",
    className: "st0",
    cx: -52,
    cy: -49.3,
    r: 4.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6d3966e30bc4d4edcf80c434971bd910.svg";
export { ForwardRef as ReactComponent };